import client from '../../client';

const addressDelete = async (id: number, sessionId: string): Promise<void> => {
  const { data } = await client.delete<void>('/address/delete', {
    data: { id, provider: 0, sessionId },
  });

  return data;
};

export default addressDelete;
